var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPeopleLight = function SvgIconPeopleLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 13.1a4.4 4.4 0 1 0 0 8.8 4.4 4.4 0 0 0 0-8.8Zm-6.6 4.4a6.6 6.6 0 1 1 13.2 0 6.6 6.6 0 0 1-13.2 0ZM8.9 31c0-2.407 1.993-4.4 4.4-4.4h15.4c2.408 0 4.4 1.993 4.4 4.4v5h-2.2v-5c0-1.192-1.007-2.2-2.2-2.2H13.3c-1.192 0-2.2 1.008-2.2 2.2v5H8.9v-5ZM29.627 11.486A6.51 6.51 0 0 1 33.6 17.5c0 2.652-1.674 5.046-3.973 6.014l-.854-2.028c1.5-.631 2.627-2.238 2.627-3.986a4.31 4.31 0 0 0-2.627-3.986l.854-2.028ZM34.7 26.6c2.408 0 4.4 1.993 4.4 4.4v5h-2.2v-5c0-1.192-1.007-2.2-2.2-2.2v-2.2Z",
    fill: "#000"
  })));
};
export default SvgIconPeopleLight;